import { CreateSubsidySettingRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateCreateSubsidySetting = makeValidator({
  FieldParser: CreateSubsidySettingRow,
});
